var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select-option',{attrs:{"value":_vm.value,"disabled":_vm.disabled}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }